import { BizParameter } from "./BizParameter";

export class BizComponent {
    id: string;
    name: string;
    executionTime: string;
    metadataId: string;
    methodCode: string;
    actualParameters: Array<BizParameter>;
    isForCompensation?: boolean;
    scopeType?: string;
}